import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { useTokensChart } from '@/hooks/useChartData'
import { format, parseISO } from 'date-fns'

export function TokenUsageChart() {
  const { data, isLoading, error } = useTokensChart(30)

  if (isLoading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">Loading chart...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">Failed to load chart data</p>
      </div>
    )
  }

  if (!data || data.labels.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center">
        <p className="text-muted-foreground">No token usage data available</p>
      </div>
    )
  }

  // Transform data for recharts
  const chartData = data.labels.map((label, index) => ({
    date: format(parseISO(label), 'MMM dd'),
    input: data.input_tokens[index] || 0,
    output: data.output_tokens[index] || 0,
  }))

  return (
    <ResponsiveContainer width="100%" height={256}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis 
          dataKey="date" 
          className="text-xs"
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
        />
        <YAxis 
          className="text-xs"
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'hsl(var(--card))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '6px',
          }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '10px',
          }}
        />
        <Bar 
          dataKey="input" 
          fill="hsl(var(--primary))" 
          name="Input Tokens"
        />
        <Bar 
          dataKey="output" 
          fill="hsl(var(--chart-2))" 
          name="Output Tokens"
        />
      </BarChart>
    </ResponsiveContainer>
  )
}
